import { GridRowsProp } from '@mui/x-data-grid';
import { any } from 'ramda';

/**
 * Keeps each row at most once, however many of its fields match; a repeated row id leaves stale rows in the grid.
 */
const filterRowsBySearch = (rows: GridRowsProp, fields: string[], searchTerm: string): GridRowsProp => {
  const term = searchTerm.toLocaleLowerCase();
  const fieldMatches = (row: GridRowsProp[number]) => (field: string) => {
    const value = row[field];
    return typeof value === 'string' && value.toLocaleLowerCase().includes(term);
  };

  return rows.filter((row) => any(fieldMatches(row), fields));
};

export default filterRowsBySearch;
